var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "deep",
    d: "M8.41855 26.6361C8.76895 26.8551 9.21797 26.836 9.54854 26.5881L41 2.99951V40.9995H1V21.9995L8.41855 26.6361Z",
    fill: "#AFB8C1",
    stroke: "#AFB8C1",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "bright",
    d: "M29 3.99951L41 16.9995V41H1V29.9995L8.1641 34.4771C8.62768 34.7668 9.23802 34.6306 9.53439 34.1712L29 3.99951Z",
    fill: "#D0D7DE",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "bright-stroke",
    d: "M1 1V41H41",
    stroke: "#D0D7DE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArea);
export default __webpack_public_path__ + "static/media/area.0ae13fa086ce0b5304ced018a53b6930.svg";
export { ForwardRef as ReactComponent };